import { Injectable } from '@angular/core';
import { ApiServiceProvider } from 'app/api-service';

@Injectable()
export class InsightSummaryBannerService extends ApiServiceProvider{

}
